/**
 * Copyright 2025-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Spacer, theme } from "@nordcloud/gnui";
import {
  SortOrder,
  FutureActionsForResourceSortFields,
} from "~/generated/graphql";
import { TableSearchInput } from "~/components/SearchInput";
import { SortSelector } from "~/components/SortSelector";
import { useQueryState } from "~/hooks";
import { ResourceDetailsActionsQuery } from "../../types/ResourceDetailsActionsQuery";
import { ResourceDetailsActionsFiltersSidebar } from "./ResourceDetailsActionsFiltersSidebar";

const sortOptions = [
  {
    value: FutureActionsForResourceSortFields.ActionName,
    label: "Action Name",
  },
  {
    value: FutureActionsForResourceSortFields.ResourceGroupName,
    label: "Resource Group Name",
  },
  {
    value: FutureActionsForResourceSortFields.EventName,
    label: "Event Name",
  },
  {
    value: FutureActionsForResourceSortFields.StartTime,
    label: "Start Time",
  },
];

export function ResourceDetailsIncomingActionsTableHeader({
  resultsCount = 0,
}: {
  resultsCount?: number;
}) {
  const { queryState, updateQueryState } =
    useQueryState<ResourceDetailsActionsQuery>();

  const handleSortDirection = (order: SortOrder) => {
    updateQueryState({
      ...queryState,
      order,
    });
  };

  const handleSortField = (field: FutureActionsForResourceSortFields) => {
    updateQueryState({
      ...queryState,
      field,
    });
  };

  const handlePhraseField = (field: string | undefined) => {
    updateQueryState({
      ...queryState,
      searchPhrase: field,
    });
  };

  return (
    <>
      <SortSelector<FutureActionsForResourceSortFields>
        options={sortOptions}
        value={queryState.field ?? FutureActionsForResourceSortFields.StartTime}
        direction={queryState.order ?? SortOrder.Asc}
        onSelect={handleSortField}
        onSortChange={handleSortDirection}
      />
      <Spacer width={theme.spacing.spacing04} />
      <TableSearchInput<ResourceDetailsActionsQuery>
        onSubmit={handlePhraseField}
        placeholder="Type a Keyword (e.g. Action Name, Resource Group Name, etc.)"
      />
      <Spacer width={theme.spacing.spacing04} />
      <ResourceDetailsActionsFiltersSidebar resultsCount={resultsCount} />
    </>
  );
}
